// extracted by mini-css-extract-plugin
module.exports = {"element":"style__element__S5mU+","bubbleMessage":"style__bubbleMessage__V-hkL","readOnly":"style__readOnly__uQ4MI"};